import './sidebar.css'
import DashboardItem from "./dashboard-item/DashboardItem";
import Passengers from "./passengers/Passengers";
import MyCompany from "./my-company/MyCompany";
import Drivers from "./drivers/Drivers";
import SendNotifications from "./send-notification/SendNotification";
import Promotions from "./promotions/Promotions";
import Reports from "./reports/Reports";
import InitialSettings from "./initial-settings/InitialSettings";
import {inject, observer} from "mobx-react";
import {Filters} from "../../../utils/HelpFunctions";
import ScrollView from "devextreme-react/scroll-view";
import ManagementBookings from "./management-bookings/ManagementBookings";
import logoWeb from '../../../assets/img/logoIku.png'

function SideBarItems(props) {

    const {DataStore} = props

    const {role, usersPermissions} = DataStore

    const passengers = usersPermissions[1].passengers
    const passengersAll = Filters(passengers, 'text', 'Todo')

    const drivers = usersPermissions[2].drivers
    const driversAll = Filters(drivers, 'text', 'Todo')

    const reports = usersPermissions[6].reports
    const reportAll = Filters(reports, 'text', 'Todo')

    const initialSettings = usersPermissions[7].initialSettings
    const initialSettingsAll = Filters(initialSettings, 'text', 'Todo')

    return (
        <div className={'sidebar-container'}>
            <div className="my-company-container">
                <img src={logoWeb} alt="" style={{width: 67, height: 50}}/>
            </div>
            <ScrollView width='100%' height='100%'>
                {usersPermissions[0].dashboard && <DashboardItem DataStore={DataStore}/>}
                {passengersAll[0].value &&
                <Passengers permissions={usersPermissions[1].passengers} DataStore={DataStore}/>}
                {driversAll[0].value && <Drivers permissions={usersPermissions[2].drivers} DataStore={DataStore}/>}
                {usersPermissions[4].notification && <SendNotifications DataStore={DataStore}/>}
                {usersPermissions[5].promotions && <Promotions DataStore={DataStore}/>}
                {usersPermissions[3].managementBookings && <ManagementBookings DataStore={DataStore}/>}
                {reportAll[0].value && <Reports permissions={reports} DataStore={DataStore}/>}
                {initialSettingsAll[0].value && <InitialSettings permissions={initialSettings} DataStore={DataStore}/>}
                {role === 'sroot' && <MyCompany DataStore={DataStore}/>}
            </ScrollView>
        </div>
    );
}

export default inject('DataStore')(observer(SideBarItems));


